import { IconTypes } from "./Icons";

export default function ArrowTopIcon({
  fontSize = "1.6rem",
  className = "",
  color = "#0077CC",
}: IconTypes) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      style={{ width: "1em", height: "1em", fontSize }}
      className={className}
    >
      <path
        d="M7.12587 0.210083H1.34306C1.26018 0.210083 1.18069 0.243007 1.12209 0.301612C1.06348 0.360217 1.03056 0.439703 1.03056 0.522583C1.03056 0.605463 1.06348 0.684949 1.12209 0.743554C1.18069 0.802159 1.26018 0.835083 1.34306 0.835083H6.51306L0.100871 7.24758C0.069874 7.27611 0.0449654 7.31061 0.0276424 7.34902C0.0103194 7.38742 0.000939676 7.42892 6.70525e-05 7.47104C-0.000805571 7.51316 0.00684692 7.55502 0.0225645 7.59411C0.0382821 7.63319 0.0617404 7.6687 0.0915292 7.69849C0.121318 7.72828 0.156822 7.75173 0.195908 7.76745C0.234994 7.78317 0.276854 7.79082 0.318973 7.78995C0.361092 7.78908 0.402599 7.7797 0.441001 7.76237C0.479402 7.74505 0.513904 7.72014 0.542434 7.68915L6.95493 1.27665V6.44696C6.95493 6.52984 6.98786 6.60932 7.04646 6.66793C7.10507 6.72653 7.18455 6.75946 7.26743 6.75946C7.35031 6.75946 7.4298 6.72653 7.4884 6.66793C7.54701 6.60932 7.57993 6.52984 7.57993 6.44696V0.664458C7.57977 0.544055 7.53189 0.428626 7.44678 0.343459C7.36167 0.258292 7.24627 0.210331 7.12587 0.210083Z"
        fill={color}
      />
    </svg>
  );
}
